import { uuid, Response } from '../../../../../_metronic/helpers';
import { Provider } from '../../../../helpers/models';
export interface Service {
  uuid: uuid;
  is_active: boolean;
  name: string;
  description: string;
  duration: number;
  prebuffer: number;
  postbuffer: number;
  lock_duration: boolean;
  is_free: boolean;
  is_recurring: boolean;
  cancellation_window: number;
  booking_window: number;
  form_template_name: string;
  bookable: boolean;
  remote_only: boolean;
}

/** WST-681: a fee (non-session) service. Prefers the backend's resolved flag. */
export const isFeeService = (ps?: ProviderService | null): boolean =>
  !!ps && (ps.is_fee ?? (ps.is_session_based ?? ps.parent?.is_session_based ?? true) === false);

export interface ProviderService {
  uuid?: uuid;
  is_active?: boolean;
  provider?: Provider;
  provider_archived?: boolean; // WST-956: read-only, the member is archived
  service?: Service;

  name?: string;
  description?: string;
  provider_description?: string;
  is_free?: boolean;
  is_recurring?: boolean;
  form_template_name?: string;
  bookable?: boolean;
  remote_only?: boolean;

  rate?: number;
  payout?: number;
  currency?: string;
  duration?: number;
  prebuffer?: number;
  postbuffer?: number;
  cancellation_window?: number;
  booking_window?: number;
  allow_referrals?: boolean;
  allow_wizclients?: boolean;
  allow_existing_client_booking?: boolean;
  hybrid_type?: string | null;
  locked_session_type?: string | null; // WST-762: read-only; non-null fixes the client's session type
  add_guardians_to_events_by_default?: boolean | null;  // WST-723
  form_followup_url?: string;
  billing_code?: string;
  billing_description?: string;
  is_session_based?: boolean | null; // WST-681: false = fee service; null inherits the parent
  fee_frequency?: 'one_time' | 'recurring' | null; // WST-681: default plan billing for a fee
  is_fee?: boolean; // WST-681: read-only, resolved
  effective_fee_frequency?: 'one_time' | 'recurring'; // WST-681: read-only, resolved

  superbill_services?: ISuperBillServiceLine[];

  parent?: ProviderService;

  children?: ProviderService[];
}

export interface ISuperBillService {
  uuid?: uuid;
  is_active?: boolean;

  provider?: Provider;

  code?: string;
  description?: string;
  duration?: number; // in minutes
  units?: number;
  dx?: string;

  rate?: number;
  currency?: string;
}

export interface ISuperBillServiceLine {
  uuid?: uuid;
  is_active?: boolean;

  code?: string;
  description?: string;
  duration?: number; // in minutes
  modifiers?: string[];

  units?: number;
  unit_rate?: number;

  total?: number;
  currency?: string;
}
